import React from 'react';
import { useHistory } from 'react-router';
import { ListItem, ListItemText, ListItemIcon, Menu, makeStyles, List } from '@material-ui/core';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import TwitterIcon from '@material-ui/icons/Twitter';
import HelpIcon from '@material-ui/icons/Help';
import SettingsIcon from '@material-ui/icons/Settings';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import { LINKS } from 'constants/index';
import useAuth from 'hooks/useAuth';
import ListItemLink from './ListItemLink';

const useStyles = makeStyles({
  accountLi: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  accountText: {
    flexGrow: 0,
  },
});

const AccountMenu: React.FC = () => {
  // Local State
  const history = useHistory();
  const classes = useStyles();
  const { signOut } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleMenuClose();
    await signOut();
    history.push('/signIn');
  };

  return (
    <List>
      <ListItem className={classes.accountLi} button onClick={handleMenuOpen}>
        <ListItemIcon>
          <AccountCircleIcon />
        </ListItemIcon>
        <ListItemText className={classes.accountText} primary="Account" />
      </ListItem>
      <Menu
        id="account-menu"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'center', horizontal: 'left' }}
      >
        <ListItem button component="a" href={LINKS.TWITTER} onClick={handleMenuClose}>
          <ListItemIcon>
            <TwitterIcon />
          </ListItemIcon>
          <ListItemText primary="Twitter" />
        </ListItem>
        <ListItem button component="a" href={LINKS.HELP} onClick={handleMenuClose}>
          <ListItemIcon>
            <HelpIcon />
          </ListItemIcon>
          <ListItemText primary="Help" />
        </ListItem>
        <ListItemLink
          to="/settings"
          label="Settings"
          icon={<SettingsIcon />}
          onClick={handleMenuClose}
        />
        <ListItem button onClick={handleLogout}>
          <ListItemIcon>
            <ExitToAppIcon />
          </ListItemIcon>
          <ListItemText primary="Log Out" />
        </ListItem>
      </Menu>
    </List>
  );
};

export default AccountMenu;
